import { createStore, applyMiddleware, compose } from 'redux'
import axios from './utils/axios'
import axiosMiddleware from 'redux-axios-middleware'
import thunk from 'redux-thunk'
import rootReducer from './redux'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export default function configureStore() {
  return createStore(rootReducer, composeEnhancers(applyMiddleware(thunk, axiosMiddleware(axios))))
}
